<script setup lang="ts">
// This component is based on https://router.vuejs.org/guide/advanced/extending-router-link.html
import { RouterLink } from 'vue-router';
import { useProject } from '@/services/projects';
import { cloneDeep } from 'lodash';

const project = useProject();

defineProps({
  // @ts-ignore
  ...RouterLink.props,
});

const setProjectQuery = (props: any): any => {
  const newProps = cloneDeep(props);

  if (project.value && !newProps.to.query?.project) {
    newProps.to.query = Object.assign(
      {
        project: project.value.id,
      },
      newProps.to.query ?? {},
    );
  }

  return newProps;
};
</script>

<template>
  <RouterLink v-bind="setProjectQuery($props)">
    <slot />
  </RouterLink>
</template>
